import CourseCard from "../courses/course-card";
import type { Course } from "~/models/course";
import { Link, useLoaderData } from "react-router";

export default function PopularCoursesSection() {
    const { courses } = useLoaderData<{ courses: Course[] | null }>();

    if (!courses || courses.length === 0) return null;

    const popularCourses = courses.slice(0, 3);

    return (
        <section id="popular-courses" className="courses">
            <div className="container" data-aos="fade-up">
                <div className="section-title">
                    <h2>Courses</h2>
                    <p>Popular Courses</p>
                </div>

                <div className="row" data-aos="zoom-in" data-aos-delay="100">
                    {popularCourses.map((course) => (
                        <div className="col-lg-4 col-md-6 d-flex align-items-stretch mb-4" key={course.id}>
                            <CourseCard course={course} />
                        </div>
                    ))}
                </div>

                <div className="text-center mt-4" data-aos="fade-up" data-aos-delay="200">
                    <Link to="/courses" className="btn btn-primary">
                        View All Courses
                    </Link>
                </div>
            </div>
        </section>
    );
}
